module.exports = __webpack_public_path__ + "media/markers/marker-orange-9e94e016.svg";